import React from 'react';
import './ChatSidebar.css';

const ChatSidebar = ({ chats, activeChatId, customers, lastReadTimestamps, onSelectChat, onCloseChat, onCollapse }) => {
  return (
    <div className="chat-sidebar-expanded">
      <div className="sidebar-header">
        <h3>Atendimentos</h3>
        {/* O botão de recolher agora chama a função passada pelo Dashboard */}
        <button className="collapse-btn" onClick={onCollapse}>—</button>
      </div>
      <div className="chat-list-vertical">
        {chats.map(chat => {
        // Pega o estado mais recente do cliente da lista principal
        const currentCustomerState = customers.find(c => c.id === chat.id);
        if (!currentCustomerState) return null; // Não renderiza se o cliente não for encontrado

        const lastRead = lastReadTimestamps[chat.id];
        // Compara o timestamp mais recente com o último lido
        const hasNewMessage = lastRead
          ? new Date(currentCustomerState.lastInteractionTimestamp) > new Date(lastRead) && chat.id !== activeChatId
          : true;

        return (
          <div
          key={chat.id}
          className={`chat-list-item ${chat.id === activeChatId ? 'active' : ''}`}
          onClick={() => onSelectChat(chat.id)}
        >
          <div className="customer-info">
            <span className="customer-name">{chat.name}</span>
          </div>
          {hasNewMessage && <span className="new-message-indicator"></span>}
          <button className="close-chat-btn" onClick={(e) => { e.stopPropagation(); onCloseChat(chat.id); }}>&times;</button>
        </div>
        );
      })}
      </div>
    </div>
  );
};

export default ChatSidebar;